import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Scrollable } from 'components/styles/scrollable';
import { Content } from './content';
import { Footer } from './footer';
import { Header } from './header';
import { LeftMenu } from './left-menu';
import { Peel } from './peel';
const PageComponent = styled.div.attrs({
    id: 'page'
})`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 8px;

  ${Scrollable};

  ${({ $gray })=>css`
    background: ${$gray ? 'var(--page-background)' : 'var(--white-100)'};
  `};

  ${Header} {
    padding: var(--layout-01) var(--layout-02) var(--layout-01);
    width: 100%;
    border-bottom: 1px solid var(--scarlet-gray-30);
    z-index: var(--zindex-layer-${({ theme })=>`0${theme.header.layer}`});
    flex: 0 0 auto;
    position: relative;
    border-radius: var(--border-radius-small) var(--border-radius-small) 0 0;
  }
  ${Content} {
    ${({ $gray })=>css`
      background: ${$gray ? 'var(--coolest-gray-10)' : 'var(--white-100)'};
    `};
    border-radius: 0 0 var(--border-radius-small) var(--border-radius-small);
    overflow: ${({ $overflow })=>$overflow ? 'auto' : 'hidden'};

    &[data-has-tabs='true'] {
      padding-bottom: 0 !important;
    }
  }
`;
const Page = PageComponent;
Page.Header = Header;
Page.Content = Content;
Page.Peel = Peel;
Page.Footer = Footer;
Page.LeftMenu = LeftMenu;
export const HeaderWithIconTitle = ({ icon, title })=>{
    return /*#__PURE__*/ _jsxs(Page.Header.Title, {
        children: [
            /*#__PURE__*/ _jsx(Page.Header.Title.Icon, {
                children: icon
            }),
            /*#__PURE__*/ _jsx(Page.Header.Title.Text, {
                children: title
            })
        ]
    });
};
export { Page };
